module.exports = __webpack_public_path__ + "static/media/swap.33343823.svg";